module.exports = __webpack_public_path__ + "static/team-17-9fed90bd3ea76df2bf6397d345bee5f6.jpg";